import React, {useLayoutEffect} from 'react';
import {RadiusView} from 'src/res/Radius';
import {FontWeightMedium} from 'src/res/FontWeight';
import {locString} from "../commons/ViewHelper";
import View from "../commons/View";
import TouchableOpacity from "../commons/TouchableOpacity";
import ImageBackground from "../commons/ImageBackground";
import AppImage from "../commons/AppImage";
import CircularProgress from "@material-ui/core/CircularProgress";
import AppUtils from "../../utils/AppUtils";
import {GAME_LOSE_AUDIO, GAME_PLAY_AUDIO, GAME_TIMER_AUDIO, GAME_WIN_AUDIO} from "../../utils/GameAudioPlayer";
import AppText from "../commons/AppText";
import {ColorWhite} from 'src/styles/Colors';
import AppIcon from 'src/js/components/commons/AppIcon';
import CardFlipView from "./CardFlipView";
import FocusHelperView from "../commons/FocusHelperView";
import GameAudio from "../commons/GameAudio";
import constants from "../../constants";
import {ACTIVITY_TYPE_MATCHING_PIC} from "../../constants/ApiConstants";
import {logDebug} from "src/js/utils/AppLog";

const GAME_DELAY_MS = 0.5 * 1000;

class FlipTileGameView extends React.Component {

  constructor(props) {
    super(props);
    this.flippedCount = 0;
    this.gameStartTime = null;
    this.backFlipIndexes = null;
    this.explicitFlipIndexes = null;
    this.setupWith(props.items, props.gameValueE);

    this.state = {
      isFetching: false,
      play: true,
      isGameOver: false,
      reload: false,
    };
  }

  componentWillUnmount() {
    if (this.intervalFunc) {
      clearInterval(this.intervalFunc);
      this.intervalFunc = null;
    }
    if (this.timeoutRef) {
      clearTimeout(this.timeoutRef);
    }
    this.stopGameTimerAudio();
  }

  simulatePlay = () => {
    if (this.props.type === constants.activity.types.GAME_FLIP_CARD) {
      const cards = new Set();
      for (let i = 0; i < this.props.rows * this.props.columns; i++) {
        cards.add(i);
      }
      this.flipCardAuto(cards, this.props.flipsNeeded - 1);
    } else if (this.props.type === constants.activity.types.GAME_MATCH_PAIR) {
      this.matchCardAuto();
    }
  }

  flipCardAuto = (cards, count) => {
    const _this = this;
    setTimeout(() => {
      if (!_this.disableFlipEvents) {
        const random = _this.getRandomIndexToFlip(cards, _this.flipppedIndexes.size <= 2);
        cards.delete(random);
        if (_this['refCard' + random]) {
          _this['refCard' + random].flip();
        }
        if (count > 0) {
          _this.flipCardAuto(cards, count - 1);
        }
      }
    }, 2000);
  }

  getRandomIndexToFlip(cards, nonDead) {
    const randomIndex = Math.floor(Math.random() * 100) % cards.size;
    let random = 0;
    let index = 0;
    cards.forEach((cardData) => {
      if (randomIndex === index) {
        random = cardData;
      }
      index++;
    });
    if (nonDead) {
      if (this.gameValue[random] === -100) {
        return this.getRandomIndexToFlip(cards, nonDead);
      }
    }
    return random;
  }

  matchCardAuto = () => {
    const _this = this;
    this.timeoutRef = setTimeout(() => {
      if (!_this.disableFlipEvents && !_this.state.isGameOver) {
        const cards = _this.getUnflippedIndexes();
        let random = -1;
        if (_this.flipppedIndexes.size % 2 === 1 && (this.flipppedIndexes.size < 4 || Math.random() > 0.8)) {
          for (let i = 0; i < _this.gameValue.length; i++) {
            if (_this.gameValue[i] === _this.gameValue[_this.lastFlippedIndex] && cards.has(i)) {
              random = i;
              break;
            }
          }
        }
        if (random === -1) {
          random = _this.getRandomIndexToFlip(cards);
        }
        _this['refCard' + random].flip();
        _this.matchCardAuto();
      }
    }, 800);
  }

  getUnflippedIndexes = () => {
    const cards = new Set();
    for (let i = 0; i < this.props.rows * this.props.columns; i++) {
      if (!this.flipppedIndexes.has(i)) {
        cards.add(i);
      }
    }
    return cards;
  }

  onDidFocus = () => {
    if (this.wasTimerRunning) {
      this.playGameTimerAudio();
    }
  }

  onDidBlur = () => {
    if (this.intervalFunc) {
      this.wasTimerRunning = true;
      this.stopGameTimerAudio();
    }
  }

  resetForPreview(items, previewCardsShow) {
    let isNeedReload = true;
    if (this.items && items && this.items.length === items.length) {
      let sameItemsCount = 0;
      for (let i = 0; i < this.items.length; i++) {
        if (this.items[i].id === items[i].id) {
          sameItemsCount++;
          if (this.items[i].imageUrl !== items[i].imageUrl) {
            this.items[i] = items[i];
          }
        }
      }
      if (sameItemsCount === this.items.length) {
        isNeedReload = false;
        this.items = items;
      }
    }
    if (isNeedReload) {
      this.reset(items);
    } else {
      this.processItems();
      this.setState({reload: !this.state.reload});
    }

    let effFlippedIndexesCount = 0;
    if (this.props.gameType === constants.activity.types.GAME_MATCH_PAIR) {
      effFlippedIndexesCount = previewCardsShow;
    } else {
      effFlippedIndexesCount = previewCardsShow - this.flipppedIndexes.size;
    }
    if (effFlippedIndexesCount > 0) {
      const indexes = this.getDefaultFlippedIndexes(effFlippedIndexesCount, this.flipppedIndexes);
      indexes.forEach((index) => {
        if (this['refCard'+ index]) {
          this['refCard'+ index].flip();
        }
      });
    }
  }

  reset(items, gameValueE) {
    this.setupWith(items, gameValueE);
    this.setState({isFetching: false, isGameOver: false, play: false, delay: false});
    const _this = this;
    setTimeout(() => {
      _this.setState({play: true});
    }, 100);
  }

  setupWith(items, gameValueE) {
    this.items = items;
    this.processGameValues();

    this.flipppedIndexes = new Set();
    this.disableFlipEvents = false;
    this.backFlipIndexes = [];
    this.explicitFlipIndexes = [];
    this.flippedCount = 0;
    this.gameStartTime = null;
    this.processItems();
  }

  processGameValues() {
    const gameValue = [];
    let totalFlips = this.getEffectiveFlips();

    if (this.props.gameType === constants.activity.types.GAME_MATCH_PAIR) {
      for (let i = 0; i < totalFlips/2; i++) {
        const itemId = this.items[i % this.items.length].id;
        gameValue.push(itemId);
        gameValue.push(itemId);
      }
    } else {
      let deadCount = this.props.deadCount;
      // deadCount = Math.min(deadCount, totalFlips - this.props.flipsNeeded);
      const firstItemId = this.items.length > 0 ? this.items[0].id : 0;
      for (let i = 0; i < totalFlips; i++) {
        if (i < totalFlips - deadCount) {
          gameValue.push(firstItemId);
        } else {
          gameValue.push(-100);
        }
      }
    }
    this.gameValue = AppUtils.shuffleArray(gameValue);
  }

  processItems() {
    this.gameItems = [];
    if (this.gameValue) {
      this.gameValue.forEach((id) => {
        // if (id === 0) {
        //   this.gameItems.push(this.getTile(id, this.props.uiConfigs.deadImage));
        // } else
        if (id === -100) {
          const image = this.props.gameType === constants.activity.types.GAME_FLIP_CARD ? this.props.uiConfigs.deadImage : null;
          this.gameItems.push(this.getTile(id, image));
        } else {
          if (this.items) {
            this.items.forEach((item) => {
              if (id === item.id) {
                this.gameItems.push(item);
              }
            });
          }
        }
      });
    }
  }

  getEffectiveFlips() {
    let totalFlips = this.props.rows * this.props.columns;
    if (this.props.gameType === constants.activity.types.GAME_MATCH_PAIR) {
      if (totalFlips % 2 === 1) {
        totalFlips--;
      }
    }
    return totalFlips;
  }

  getDefaultFlippedIndexes(flipCount, exceptIndexes = null) {
    if (this.props.gameType === constants.activity.types.GAME_MATCH_PAIR) {
      const flipIndexes = [];
      const exceptElementIds = [];
      if (exceptIndexes) {
        exceptIndexes.forEach((exceptIndex) => {
          exceptElementIds.push(this.gameValue[exceptIndex]);
        });
      }
      for (let i = 0; i < this.items.length; i++) {
        const elementId = this.items[i].id;
        if (exceptElementIds && exceptElementIds.includes(elementId)) {
          continue;
        }
        let count = 0;
        for (let j = 0; j < this.gameValue.length; j++) {
          if (this.gameValue[j] === elementId) {
            flipIndexes.push(j);
            count++;
          }
          if (count === 2) {
            break;
          }
        }
      }
      return flipIndexes;
    }
    let nonDeadIndexes = [];
    for (let i = 0; i < this.gameValue.length; i++) {
      if (this.gameValue[i] !== -100 && (!exceptIndexes || !exceptIndexes.has(i))) {
        nonDeadIndexes.push(i);
      }
    }
    nonDeadIndexes = AppUtils.shuffleArray(nonDeadIndexes);
    return nonDeadIndexes.splice(0, flipCount);
  }

  playGamePlayAudio() {
    if (this.gamePlayAudioId) {
      this.gamePlayAudioId.play();
    }
  }

  playGameLoseAudio() {
    if (this.gamePlayAudioIdLose) {
      this.gamePlayAudioIdLose.play();
    }
  }

  playGameTimerAudio() {
    if (this.gameTimerAudioId) {
      this.gameTimerAudioId.play();
    }
  }

  stopGameTimerAudio() {
    if (this.gameTimerAudioId) {
      this.gameTimerAudioId.pause();
    }
  }

  render() {
    const isLTR = this.props.isLTR;
    const uiConfigs = this.props.uiConfigs;
    const sizeFactor = uiConfigs.sizeFactor;
    const isDisabled = this.props.disabled || this.state.isGameOver;
    const rows = this.props.rows;
    const columns = this.props.columns;

    const cardSize = this.getCardSize();
    const cardSpacing = this.getCardSpacing();
    const allFlipsWidth = (cardSize + cardSpacing) * columns + 1;
    const allFlipsHeight = (cardSize + cardSpacing) * rows + 1;
    const flipBgMargin = uiConfigs.flipBgMarginStartEnd * sizeFactor;
    const flipBgMarginTop = uiConfigs.flipBgMarginTop * sizeFactor;
    const flipBgMarginBottom = uiConfigs.flipBgMarginBottom * sizeFactor;

    let gameTimeLeft = this.props.gameTime / 1000;
    if (this.gameStartTime) {
      const nowTimer = new Date().getTime();
      gameTimeLeft = Math.max(0, parseInt((this.props.gameTime - (nowTimer - this.gameStartTime)) / 1000));
    }
    return (
      <View style={{alignItems: 'center', paddingBottom: uiConfigs.collectionImage ? 28 * sizeFactor : 0}}>
        <FocusHelperView
          onAppDidFocus={this.onDidFocus}
          onAppDidBlur={this.onDidBlur}
        />
        {!this.props.disableAudio ?
          <div>
            <GameAudio ref={(ref) => this.gamePlayAudioId = ref} source={this.props.gamePlayAudioUrl || GAME_PLAY_AUDIO} autoPlay={false} loop={false} hasUserInteraction={true} mute={this.props.mute} />
            <GameAudio ref={(ref) => this.gameTimerAudioId = ref} source={GAME_TIMER_AUDIO} autoPlay={false} loop={true} hasUserInteraction={true} mute={this.props.mute} />
            <GameAudio ref={(ref) => this.gamePlayAudioIdLose = ref} source={this.props.gameLoseAudioUrl || GAME_LOSE_AUDIO} autoPlay={false} loop={false} hasUserInteraction={true} mute={this.props.mute} />
            <GameAudio ref={(ref) => this.gamePlayAudioIdWin = ref} source={this.props.gameWinAudioUrl || GAME_WIN_AUDIO} autoPlay={false} loop={false} hasUserInteraction={true} mute={this.props.mute} />
          </div>
          : null
        }
        <View
          style={{flexDirection: 'row', alignItems: 'flex-end', justifyContent: 'center', padding: 8, paddingTop: 0, opacity: this.props.flipsNeeded > 1 ? 1 : 0}}>
          <ImageBackground
            source={uiConfigs.flipCounterImage}
            resizeMode="fill"
            style={{
              height: 44 * sizeFactor,
              width: 110 * sizeFactor,
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center'
          }}>
            <View
              style={{position: 'relative',
                flex: 1,
                marginLeft: 40 * sizeFactor,
                marginRight: 8 * sizeFactor,
                marginTop: 4 * sizeFactor,
                justifyContent: 'center',
                alignItems: 'center'}}>
              <AppText
                fontSizeN={uiConfigs.fontSize}
                style={{
                  fontWeight: FontWeightMedium,
                  color: uiConfigs.gameValueTextColor}}>
                {locString('activity.twoValues', {value1: this.flippedCount, value2: this.props.flipsNeeded})}
                {/*{Math.max(0, this.props.flipsNeeded - this.flippedCount)}*/}
              </AppText>
            </View>
          </ImageBackground>
          {this.props.gameTime ?
            <ImageBackground source={uiConfigs.timerImage} resizeMode="fill" style={{
              height: 44 * sizeFactor,
              width: 110 * sizeFactor,
              flexDirection: 'row',
              alignItems: 'center',
              marginLeft: 40
            }}>
              <AppText
                fontSizeN={uiConfigs.fontSize}
                style={{fontSize: 18, fontWeight: FontWeightMedium, color: uiConfigs.gameValueTextColor, flex: 1, marginLeft: isLTR ? 38 : 8, marginRight: isLTR ? 8 : 38, justifyContent: 'center'}}>
                {locString('agoSecondShort', {0: gameTimeLeft})}
              </AppText>
            </ImageBackground>
            : null
          }
        </View>
        {/*<ImageBackground*/}
        {/*  source={uiConfigs.gameBgTopImage}*/}
        {/*  resizeMode="fill"*/}
        {/*  style={{*/}
        {/*    height: 36 * sizeFactor,*/}
        {/*    width: 280 * sizeFactor,*/}
        {/*    display: 'flex',*/}
        {/*    alignItems: 'center',*/}
        {/*    justifyContent: 'center',*/}
        {/*    paddingTop: 4*/}
        {/*}}>*/}
        {/*  <AppText fontSizeN={uiConfigs.fontSize} style={{position: 'relative', fontWeight: FontWeightMedium, color: uiConfigs.titleColor}}>*/}
        {/*    {this.props.name}*/}
        {/*  </AppText>*/}
        {/*</ImageBackground>*/}
        {uiConfigs.collectionImage ?
          <View
            style={{position: 'absolute', bottom: 0, left: 0, right: 0, height: 36 * sizeFactor, alignItems: 'center'}}>
            <View style={{width: 100 * sizeFactor, height: 36 * sizeFactor, paddingTop: 6 * sizeFactor}}>
              <ImageBackground source={uiConfigs.collectionImage} resizeMode="fill"
                               style={{position: 'absolute', left: 0, top: 0, bottom: 0, right: 0}}/>
              <View style={{alignItems: 'center', justifyContent: 'center'}}>
                <AppText
                  fontSizeN={uiConfigs.fontSize}
                  style={{
                    fontWeight: FontWeightMedium,
                    color: uiConfigs.gameValueTextColor
                }}>{this.props.collectedValue}</AppText>
              </View>
            </View>
          </View>
          : null
        }
        <View
          style={{
            display: 'flex',
            flexDirection: 'row',
            height: allFlipsHeight + flipBgMarginTop + flipBgMarginBottom,
            width: allFlipsWidth + 2 * flipBgMargin,
            alignItems: 'center',
            justifyContent: 'center',
            overflow: 'hidden'
          }}>
          <CardsView
            onRef={this.onRef}
            uiConfigs={uiConfigs}
            isDisabled={isDisabled}
            rows={this.props.rows}
            columns={this.props.columns}
            cardSize={cardSize}
            cardSpacing={cardSpacing}
            cardImage={this.props.cardImage}
            gameItems={this.gameItems}
            play={this.state.play}
            onCardFlipStart={this.onCardFlipStart}
            onCardFlipEnd={this.onCardFlipEnd}
            onClickCard={this.onClickCard}
          />
          {!this.props.simulation && ((this.state.isGameOver && this.state.delay) || this.state.isFetching) ?
            <View style={{position: 'absolute', top: 15 * sizeFactor, bottom: 0, right: 0, left: 0, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
              <CircularProgress size={54 * sizeFactor} style={{color: uiConfigs.messageBgColor}}/>
            </View>
            : null
          }
        </View>
      </View>
    );
  }

  processGameTimer() {
    this.gameStartTime = new Date().getTime();
    this.intervalFunc = setInterval(() => {
      const nowTimer = new Date().getTime();
      if (nowTimer - this.gameStartTime >= this.props.gameTime) {
        this.setState({isGameOver: true});
        this.processLose(-100);
      } else {
        this.setState({reload: !this.state.reload});
      }
    }, 1000);
    this.playGameTimerAudio();
  }

  onRef = (ref, key) => {
    this['refCard'+ key] = ref;
  }

  onClickCard = (index) => {
    if (this.props.noActionMode) {
      this.props.onActionClickedInNoActionMode();
      return;
    }
    if (this.flippedCount === 0) {
      const _this = this;
      setTimeout(() => {
        if (_this.props.onStart) {
          _this.props.onStart();
        }
      });
    }

    this['refCard' + index].flip();
  };

  onCardFlipStart = (item, index) => {
    const explicitFlipIndex = this.explicitFlipIndexes.indexOf(index);
    if (explicitFlipIndex !== -1) {
      return;
    }

    if (!this.state.isGameOver) {
      if (item.id === -100) {
        this.setState({isGameOver: true});
      } else {
        if (this.props.gameTime > 0 && this.flippedCount === 0) {
          this.processGameTimer();
        }
        this.flippedCount++;
        this.flipppedIndexes.add(index);

        // if (this.props.gameType === ACTIVITY_TYPE_FIND_HIDDEN && item.id > 0) {
        //   this.setState({isGameOver: true});
        // } else
        if (this.props.gameType === ACTIVITY_TYPE_MATCHING_PIC) {
          if (this.lastFlippedIndex !== undefined) {
            const lastItem = this.gameItems[this.lastFlippedIndex];
            if (lastItem.id !== item.id) {
              this.backFlipIndexes.push(this.lastFlippedIndex);
              this.backFlipIndexes.push(index);
              this.flipppedIndexes.delete(this.lastFlippedIndex);
              this.flipppedIndexes.delete(index);
            }
            this.lastFlippedIndex = undefined;
          } else {
            this.lastFlippedIndex = index;
          }
          if (this.flipppedIndexes.size === this.getEffectiveFlips()) {
            this.setState({isGameOver: true});
          } else if (this.flippedCount === this.props.flipsNeeded) {
            this.setState({isGameOver: true});
          } else {
            this.setState({reload: !this.state.reload});
          }
        } else {
          if (this.flipppedIndexes.size === this.props.flipsNeeded) {
            this.setState({isGameOver: true});
          } else {
            this.setState({reload: !this.state.reload});
          }
        }
        this.playGamePlayAudio();
      }
    }
  }

  onCardFlipEnd = (item, index) => {
    const explicitFlipIndex = this.explicitFlipIndexes.indexOf(index);
    if (explicitFlipIndex !== -1) {
      this.explicitFlipIndexes.splice(explicitFlipIndex, 1);
      return;
    }

    if (!this.disableFlipEvents) {
      if (item.id === -100) {
        this.processLose(index);
      }
      // else if (this.props.gameType === ACTIVITY_TYPE_FIND_HIDDEN && item.id > 0) {
      //   this.processWin(index, 2000);
      // } else
      if (this.props.gameType === ACTIVITY_TYPE_MATCHING_PIC) {
        const flipBackIndex = this.backFlipIndexes.indexOf(index);
        if (flipBackIndex > 0) {
          let count = 0;
          this.backFlipIndexes.forEach((backFlipIndex) => {
            if (count <= flipBackIndex) {
              if (this['refCard' + backFlipIndex]) {
                this.explicitFlipIndexes.push(backFlipIndex);
                this['refCard' + backFlipIndex].flip();
              }
            }
            count++;
          });
          this.backFlipIndexes = this.backFlipIndexes.filter(x => !this.explicitFlipIndexes.includes(x));
        }
        if (this.flipppedIndexes.size === this.getEffectiveFlips()) {
          this.processWin(index, 1000);
        } else if (this.flippedCount === this.props.flipsNeeded) {
          this.processLose(index);
        }
      } else {
        if (this.flipppedIndexes && this.flipppedIndexes.size > 0) {
          let values = [];
          this.flipppedIndexes.forEach((index) => {
            values.push(this.gameItems[index]);
          });
          if (this.props.onFlipped) {
            this.props.onFlipped(values);
          }
        }
        if (this.flipppedIndexes.size >= this.props.flipsNeeded) {
          // if (this.props.gameType === ACTIVITY_TYPE_FIND_HIDDEN) {
          //   this.processLose(index);
          // } else {
            this.processWin(index, 1000);
          // }
        }
      }
    }
  }

  processLose(index) {
    if (this.intervalFunc) {
      clearInterval(this.intervalFunc);
      this.intervalFunc = null;
    }
    this.stopGameTimerAudio();
    const _this = this;
    setTimeout(() => {
      _this.playGameLoseAudio();
      _this.gameOver(index);
    }, 100);
    setTimeout(() => {
      if (_this.props.onLose) {
        const endGameValues = _this.getBaseEndGameValues();
        endGameValues.isLose = true;
        _this.props.onLose(endGameValues);
      }
      _this.setState({delay: false, isFetching: true});
    }, 2000);
    this.setState({delay: true});
  }

  processWin(index, delayMS = GAME_DELAY_MS) {
    if (this.intervalFunc) {
      clearInterval(this.intervalFunc);
      this.intervalFunc = null;
    }
    this.stopGameTimerAudio();
    if (this.props.flipAllOnWin) {
      this.gameOver(index);
    } else {
      // Vibration.vibrate(200);
    }
    if (this.props.onWin) {
      const _this = this;
      setTimeout(() => {
        const endGameValues = _this.getBaseEndGameValues();
        endGameValues.isWin = true;
        _this.props.onWin(endGameValues);
      }, 2000);
      this.setState({delay: true, isFetching: true});
    }
  }

  getBaseEndGameValues() {
    const gameEndIndexes = [];
    const gameEndValues = [];
    this.flipppedIndexes.forEach((index) => {
      const id = this.gameItems[index].id;
      let isIdValid = id > 0;
      if (this.props.gameType === constants.activity.types.GAME_MATCH_PAIR) {
        isIdValid = true;
      }
      if (isIdValid) {
        gameEndIndexes.push(index);
        gameEndValues.push(this.gameItems[index].id);
      }
    });
    return {indexes: gameEndIndexes, values: gameEndValues};
  }

  gameOver(index) {
    const flipsSize = this.getEffectiveFlips();
    this.disableFlipEvents = true;
    for (let i = 0; i < flipsSize; i++) {
      if (this['refCard' + i]) {
        if (index !== i && !this.flipppedIndexes.has(i)) {
          this['refCard' + i].flip();
        }
      }
    }
    // Vibration.vibrate(200);
  }

  getTile(id, imageUrl) {
    const tile = {
      id: id,
    };
    if (imageUrl) {
      tile.imageUrl = imageUrl;
    }
    return tile;
  }

  getCardSize() {
    const uiConfigs = this.props.uiConfigs;
    const sizeFactor = uiConfigs.sizeFactor;
    const cardSpacing = this.getCardSpacing();

    const rows = this.props.rows;
    const columns = this.props.columns;

    const flipBgMargin = uiConfigs.flipBgMarginStartEnd * sizeFactor;
    const flipBgMarginTop = uiConfigs.flipBgMarginTop * sizeFactor;
    const flipBgMarginBottom = uiConfigs.flipBgMarginBottom * sizeFactor;
    const borderWidth = 2 * flipBgMargin;
    const borderHeight = flipBgMarginTop + flipBgMarginBottom;
    const otherUiHeight = 110 * sizeFactor;

    const possibleWidth = (this.props.contentWidth - 2 - borderWidth - (columns + 1) * cardSpacing) / columns; // viewMargin, borderWidth, margin to each card
    const possibleHeight = (this.props.contentHeight - otherUiHeight - 2 - borderHeight - (rows - 1) * cardSpacing) / rows; // viewMargin, borderWidth, margin to each card
    const possibleSize = Math.min(possibleWidth, possibleHeight);
    const cardSize = Math.floor(Math.min(200, possibleSize));
    return cardSize;
  }

  getCardSpacing() {
    const uiConfigs = this.props.uiConfigs;
    const sizeFactor = uiConfigs.sizeFactor;
    return Math.ceil(2 * sizeFactor);
  }
}

const CardsView = (props) => {
  const {uiConfigs, isDisabled, rows, columns, cardSize, cardSpacing, cardImage, gameItems,
    play,
    onRef, onCardFlipStart, onCardFlipEnd, onClickCard} = props;
  const sizeFactor = uiConfigs.sizeFactor;

  const allFlipsWidth = cardSize*columns + cardSpacing*(columns-1) + 1;
  const allFlipsHeight = cardSize*rows + cardSpacing*(rows-1) + 1;
  const flipBgMargin = uiConfigs.flipBgMarginStartEnd * sizeFactor;
  const flipBgMarginTop = uiConfigs.flipBgMarginTop * sizeFactor;
  const flipBgMarginBottom = uiConfigs.flipBgMarginBottom * sizeFactor;

  // let gameTimeLeft = this.props.gameTime / 1000;
  // if (this.gameStartTime) {
  //   const nowTimer = new Date().getTime();
  //   gameTimeLeft = Math.max(0, parseInt((this.props.gameTime - (nowTimer - this.gameStartTime)) / 1000));
  // }

  return (
    <ImageBackground source={uiConfigs.gameBgImage} resizeMode="fill" style={{
      display: 'flex',
      flexDirection: 'row',
      height: allFlipsHeight + flipBgMarginTop + flipBgMarginBottom,
      width: allFlipsWidth + 2 * flipBgMargin,
      padding: flipBgMargin,
      paddingTop: flipBgMarginTop,
      paddingBottom: flipBgMarginBottom,
      alignItems: 'center',
      justifyContent: 'center',
    }}>
      <View style={{position: 'relative', display: 'flex', flexDirection: 'row', flexWrap: 'wrap', overflow: 'hidden', paddingLeft: 5 * sizeFactor}}>
        {play && gameItems.map((item, index) => {
          return (
            <CardView
              key={index}
              item={item}
              cardSize={cardSize}
              cardSpacing={cardSpacing}
              index={index}
              onRef={onRef}
              onClickCard={onClickCard}
              onCardFlipStart={onCardFlipStart}
              onCardFlipEnd={onCardFlipEnd}
              cardBgImage={uiConfigs.cardBgImage}
              cardImage={cardImage}
              isDisabled={isDisabled}
            />
          )
        })}
      </View>
    </ImageBackground>
  );
};

const CardView = (props) => {
  const {item, cardSize, cardSpacing, index, onRef, onClickCard, onCardFlipStart, onCardFlipEnd,
    cardBgImage, cardImage, isDisabled} = props;

  const onClickCardL = () => {
    onClickCard(index);
  }
  const onRefL = (ref) => {
    onRef(ref, index);
  }
  const onCardFlipStartL = () => {
    onCardFlipStart(item, index);
  }
  const onCardFlipEndL = () => {
    onCardFlipEnd(item, index);
  }
  return (
    <CardFlipView
      key={index}
      style={{
        margin: cardSpacing / 2,
        width: cardSize,
        height: cardSize,
        alignItems: 'center',
        justifyContent: 'center',
        opacity: isDisabled ? 0.7 : 1
      }}
      onFlipStart={onCardFlipStartL}
      onFlipEnd={onCardFlipEndL}
      ref={onRefL}>
      <TouchableOpacity
        disabled={isDisabled}
        onClick={onClickCardL}
        style={{width: cardSize, height: cardSize, borderRadius: RadiusView}}>
        <View style={{width: cardSize, height: cardSize}}>
          <ImageBackground
            source={cardBgImage}
            resizeMode="fill"
            style={{width: cardSize, height: cardSize, padding: 4}}>
            <View style={{position: 'relative', flex: 1, alignItems: 'center', justifyContent: 'center'}}>
              <AppImage
                source={cardImage}
                style={{width: cardSize - 8, height: cardSize - 8, borderRadius: 4}}/>
            </View>
          </ImageBackground>
        </View>
      </TouchableOpacity>
      <GetView item={item} cardSize={cardSize} />
    </CardFlipView>
  )
}

const GetView = (props) => {
  const {item, cardSize} = props;
    const spacing = 8;
    return (
      <View style={{
        width: cardSize,
        height: cardSize,
        padding: spacing,
        borderWidth: 0,
        borderColor: ColorWhite,
        borderRadius: RadiusView,
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        {item.imageUrl ?
          <AppImage
            style={{
              height: cardSize - spacing,
              width: cardSize - spacing,
              borderRadius: RadiusView
            }}
            imageUrl={item.imageUrl}
            resizeMode={'contain'}
          />
          : item.icon
            ? <View style={{backgroundColor: item.bgColor, padding: 4, borderRadius: 24}}>
              <AppIcon icon={item.icon} color={item.color} size={40}/>
            </View>
            : null
        }
      </View>
    );
};

export default FlipTileGameView;
